import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0efe4af8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "b5" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Encontre aqui a sua loja ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Digite a Cidade")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: "/assets/img/carrinho.svg"
}, null, -1))
const _hoisted_6 = {
  class: "ion-padding",
  slot: "content"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/google-maps.png" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_alert = _resolveComponent("ion-alert")!
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_accordion = _resolveComponent("ion-accordion")!
  const _component_ion_badge = _resolveComponent("ion-badge")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_accordion_group = _resolveComponent("ion-accordion-group")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_FooterMenu = _resolveComponent("FooterMenu")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_alert, {
        "is-open": _ctx.isOpenRef,
        header: "Ativação",
        "sub-header": "Important message",
        message: "Ativado com sucesso",
        buttons: ['OK'],
        onDidDismiss: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setOpen(false)))
      }, null, 8, ["is-open"]),
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                size: "12",
                class: "ion-text-center font-montserrat font-25 layout_blue"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, [
                    _createVNode(_component_ion_icon, { icon: _ctx.locationOutline }, null, 8, ["icon"])
                  ]),
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_ion_item, { class: "ion-item-input" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_label, {
                position: "floating",
                color: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_ion_input, {
                modelValue: _ctx.nomeCidade,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.nomeCidade) = $event)),
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.nomeCidade=$event.target.value)),
                name: "nomeCidade",
                type: "text",
                spellcheck: "false",
                autocapitalize: "on"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _hoisted_4,
          _createVNode(_component_ion_accordion_group, null, {
            default: _withCtx(() => [
              (_ctx.carregando)
                ? (_openBlock(), _createBlock(_component_ion_accordion, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { slot: "header" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            class: "ion-text-center font-montserrat font-25",
                            size: "12"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_spinner, { name: "circular" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojas, (cidade, index) => {
                return (_openBlock(), _createBlock(_component_ion_accordion, {
                  value: 'cidade_'+index
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_item, { slot: "header" }, {
                      default: _withCtx(() => [
                        _hoisted_5,
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cidade[0].cidade), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_ion_badge, {
                          color: "jauservelayoutvermelho",
                          slot: "end"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(cidade.length), 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_ion_list, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cidade, (loja, index) => {
                            return (_openBlock(), _createBlock(_component_ion_item, {
                              onClick: ($event: any) => (_ctx.showMap(loja)),
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_avatar, { slot: "end" }, {
                                  default: _withCtx(() => [
                                    _hoisted_7
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_label, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("h2", null, _toDisplayString(loja.nome), 1),
                                    _createElementVNode("h3", null, "Telefone:" + _toDisplayString(loja.telefone), 1),
                                    _createElementVNode("h1", null, [
                                      _createTextVNode(_toDisplayString(loja.endereco) + " ", 1),
                                      _hoisted_8,
                                      _createTextVNode(" " + _toDisplayString(loja.bairro) + " - " + _toDisplayString(loja.cidade), 1)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1032, ["value"]))
              }), 256))
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FooterMenu, { data: {inicial:false} })
    ]),
    _: 1
  }))
}